import { PaymentProvider } from '../../context/PaymentContext';

export const PaymentLayout = ({ children }) => {
    return <PaymentProvider>{children}</PaymentProvider>;
};
